<template>
  <div class="intelligent-booking-result-container">
    <!-- 主要内容区域 -->
    <div class="main-content-area">
      <cargo-left-right-resize
        class="content-resize-container"
        :left-style="{'min-width': '550px',width:'50%'}"
        :right-style="{'min-width': '550px',width:'50%'}"
      >
        <template slot="left">
          <div class="left-panel">
            <image-preview-cwmi ref="imagePreviewCwmi" :image-info="resultArray[pageNum-1].pointer" :cur-focus="curFocus" />
          </div>
        </template>
        <template slot="right">
          <div class="right-panel">
            <!-- 右上角切换模式 -->
            <div v-if="details.identificationType === SENDING_2.code" class="toggle-mode-container">
              <span class="toggle-label">{{ $t('CargoMsg.Cargo_DisplayDifferenceInformation') }}</span>
              <el-switch
                v-model="showDifferenceOnly"
                active-color="#1890ff"
                inactive-color="#dcdfe6"
                @change="handleToggleChange"
              />
            </div>

            <!-- 内容区域 -->
            <div class="form-content-area">
              <!--        海出托书-->
              <div v-if="details.identificationType === SENDING_0.code" class="form-container">
                <result-form-se
                  ref="resultForm"
                  :details="details"
                  :result-array="resultArray"
                  :index="pageNum-1"
                  :source="source"
                  @fieldFocus="(val)=>{
                    curFocus = val
                    $refs.imagePreviewCwmi.curFocusChange(val)
                    resultArray[pageNum-1].curFocus=val
                  }"
                />
              </div>
              <!--        空出托书-->
              <div v-if="details.identificationType === SENDING_4.code" class="form-container">
                <result-form-ae
                  ref="resultForm"
                  :details="details"
                  :result-array="resultArray"
                  :index="pageNum-1"
                  :source="source"
                  @fieldFocus="(val)=>{
                    curFocus = val
                    $refs.imagePreviewCwmi.curFocusChange(val)
                    resultArray[pageNum-1].curFocus=val
                  }"
                />
              </div>
              <!--        空进提单-->
              <div v-if="details.identificationType === SENDING_5.code" class="form-container">
                <result-form-ai
                  ref="resultForm"
                  :details="details"
                  :result-array="resultArray"
                  :index="pageNum-1"
                  :source="source"
                  @fieldFocus="(val)=>{
                    curFocus = val
                    $refs.imagePreviewCwmi.curFocusChange(val)
                    resultArray[pageNum-1].curFocus=val
                  }"
                />
              </div>
              <div v-if="details.identificationType === SENDING_2.code" class="form-container">
                <result-form-se-td
                  ref="resultForm"
                  :details="details"
                  :result-array="resultArray"
                  :index="pageNum-1"
                  :source="source"
                  :show-all="showAll"
                  @fieldFocus="(val)=>{
                    curFocus = val
                    $refs.imagePreviewCwmi.curFocusChange(val)
                    resultArray[pageNum-1].curFocus=val
                  }"
                />
              </div>
            </div>
          </div>
        </template>
      </cargo-left-right-resize>
    </div>

    <!-- 底部区域 - 分页和按钮 -->
    <div class="bottom-area">
      <!--分页 - 居中显示-->
      <div class="pagination-container">
        <el-pagination
          background
          :current-page.sync="pageNum"
          :pager-count="5"
          :page-size="1"
          layout="prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <!-- 右下角按钮 - 根据状态和类型显示不同按钮 -->
      <div class="bottom-buttons">
        <!-- 已完成状态 - 只显示关闭按钮 -->
        <template v-if="details.status === 3">
          <el-button no="1" type="primary" @click="handleClose">{{ $t('Message.Close') }}</el-button>
        </template>
        <!-- 托书功能按钮 - 显示保存和关闭 -->
        <template v-else-if="[SENDING_0.code, SENDING_4.code, SENDING_5.code].indexOf(details.identificationType) > -1">
          <el-button no="2" type="success" @click="handleSave">{{ $t('Payment.save') }}</el-button>
          <el-button no="4" @click="refresh">{{ $t('Message.Close') }}</el-button>
        </template>
        <!-- 提单识别类型 - 显示覆盖和关闭 -->
        <template v-else-if="details.identificationType === SENDING_2.code">
          <el-button no="4" type="primary" @click="overrideSystemBillHandler">{{ $t('CargoMsg.Cargo_OverrideSystemBillOfLading') }}</el-button>
          <el-button no="4" @click="refresh">{{ $t('Message.Close') }}</el-button>
        </template>
      </div>
    </div>
    <!--    &lt;!&ndash;敏感词弹窗&ndash;&gt;-->
    <!--    <el-dialog-->
    <!--      no="checkSensitiveWordDialog"-->
    <!--      :visible.sync="checkSensitiveWordDialog.visible"-->
    <!--      :title="$t('Message.WarmReminder')"-->
    <!--      width="630px"-->
    <!--      append-to-body-->
    <!--    >-->
    <!--      <div v-for="(checkSensitiveWordResult,index) in checkSensitiveWordDialog.checkSensitiveWordResults" :key="index">-->
    <!--        <div>{{ $t('CargoMsg.Cargo_Book') + (checkSensitiveWordResult.index + 1) }}</div>-->
    <!--        <div v-html="checkSensitiveWordResult.message" />-->
    <!--      </div>-->
    <!--      <div slot="footer" style="text-align: center">-->
    <!--        <el-button type="primary" @click="params.ifBooking = true; saveAndBooking()">{{ $t('CargoMsg.Cargo_Booking') }}</el-button>-->
    <!--        <el-button type="primary" @click="params.ifBooking = false; saveAndBooking()">{{ $t('CargoMsg.Cargo_OnlyGenerateJob') }}</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <!--保存并订舱结果弹窗-->
    <el-dialog
      no="saveAndBookingDialog"
      :visible.sync="saveAndBookingDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 40px 20px 40px">
        <div v-for="(item,index) in saveAndBookingDialog.data" v-show="jobList.length === 0" :key="index">
          <div v-html="(index + 1) + '.' + item + '</br></br>'" />
        </div>
        <cargo-ag-grid
          v-show="jobList.length > 0"
          config-module="3300012"
          :grid-options="gridOptions"
          :column-defs="gridOptions.columnDefs"
          :row-data="jobList || []"
          style="height: 200px"
          @gridReady="params=>{gridOptions.gridApi=params.api}"
        />
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveAndBookingDialogClose">{{ $t('Message.GotIt') }}</el-button>
        <el-button v-show="jobList.length > 0" type="primary" @click="exportTemplateHandler">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button v-show="jobList.length > 0" type="primary" @click="copyHandler">{{ $t('CargoMsg.Cargo_UpdateBusinessAgain') }}</el-button>
      </div>
    </el-dialog>
    <!--信控校验弹窗-->
    <el-dialog
      no="creditValidDialog"
      :visible.sync="creditValidDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="630px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 40px 20px 40px">
        <div v-for="(item, index) in creditValidDialog.data" :key="index">
          <div>
            {{ $t('CargoMsg.Cargo_Book') + item[0] }}
          </div>
          <div style="margin-left: 20px" v-html="item[1]" />
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="creditValidDialog.visible = false">{{ $t('Message.GotIt') }}</el-button>
      </div>
    </el-dialog>

    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :batch-create-job="true"
      :append-to-body="true"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :close-callback="batchCheckingWindow.closeCallback"
    />
    <!--    打印报表-->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :lob="lob"
      :context="this"
      :print-channel="1"
      :pre-print-callback="templateSelectorDialog.prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreviewCwmi from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ImagePreviewCwmi'
import ResultFormSe from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ResultFormSe'
import ResultFormAe from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ResultFormAe'
import ResultFormAi from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ResultFormAi'
import ResultFormSeTd from '@/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ResultFormSeTd'
import { copyIntelligentDocumentFunc, overrideSystemBillFunc, saveResultJsonCwmi } from '@/api/seaExport/intelligentBooking'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import {
  AE, AI, INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE,
  JOB_BOOKING_STATE_BOOKING,
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS, JOB_BOOKING_STATE_RECORDED_NOT_BOOKING,
  LOG_SE_SEA_BOOKING, SALES_CHANNEL_OCR_RECOGNITION,
  SE,
  SENDING_0, SENDING_2, SENDING_3, SENDING_4, SENDING_5,
  SOURCE_REMOTE_BOOKING_SAVE, UPLOAD_STATUS_COMPLETE_ORDER
} from '@/class/cargo/model/parameters/SystemConstants'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { batchSaveSeaBookingSpaceAndBook } from '@/api/seaExport/seaExportJob'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { canCreateByCreditInfoDetails } from '@/api/partner/creditInfo'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { getUuid } from '@/utils'
import lodash from 'lodash'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog.vue'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { getTemplateName } from '@/api/sysManage/baseConfig/template'
import { checkBsItemOpened } from '@/api/booking/job'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export default {
  name: 'IntelligentBookingResultCommon',
  components: { cargoTemplateSelectorDialog, BatchCheckingWindow, ResultFormSe, ImagePreviewCwmi, CargoLeftRightResize, ResultFormAe, ResultFormAi, ResultFormSeTd },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      templateValidRegex1: /code7:(.*?)(?=】)/,
      templateValidRegex2: /【code7:(.*?)】/g,
      curFocus: '',
      showAll: false,
      SENDING_0, SENDING_2, SENDING_3, SENDING_4, SENDING_5,
      pageNum: 1, // 当前页
      showJudgmentOfVoyageNo: false,
      creditOpen: false,
      useCheckRule: false,
      packingList: [],
      newJobList: [],
      checkSaveJobList: [], // 检查出需要保存的数据
      checkBookingJobList: [], // 检查出需要订舱的数据
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {},
        prePrintCallback: null
      },
      printedCallback: null,
      v2CheckCallback: null,
      selectedItem: null,
      gridOptions: {
        gridApi: null,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobNo', width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: false,
                  jumpMethod: value => {
                    if (this.details.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code ||
                      this.details.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code) {
                      this.$router.push({ name: 'RemoteBooking', query: { jobNo: value }})
                    } else {
                      doJumpFinaceOrBusiness(this, value, data.lob, data.opOffice, true)
                    }
                    this.closeDialog()
                  }
                }
              }
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Status'), field: 'saveOrBooking', minWidth: 50, colId: 'saveOrBooking' },
          {
            headerName: this.$t('CargoMsg.Cargo_ResultMessage'), field: 'errorMessage', minWidth: 160, colId: 'errorMessage'
          }
        ],
        onRowClicked: this.onRowClicked
      },
      jobList: [],
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        closeCallback: null,
        callBack2: null
      },
      // checkSensitiveWordDialog: {
      //   visible: false,
      //   checkSensitiveWordResults: [] // 敏感词校验结果
      // },
      saveAndBookingDialog: {
        visible: false,
        data: [] // 保存并订舱结果弹窗
      },
      loading: null,
      params: null,
      resultArray: [],
      JobUtils,
      creditValidDialog: {
        visible: false,
        data: [] // 信控校验弹窗
      }
    }
  },
  computed: {
    // resultArray() {
    //   return this.details.resultJson ? JSON.parse(this.details.resultJson) : null
    // },
    total() { // 总页数
      return JSON.parse(this.details.resultJson).length
    },
    lob() { // 业务类型
      if ([SENDING_0.code].indexOf(this.details.identificationType) > -1) {
        return SE.code
      }
      if ([SENDING_4.code].indexOf(this.details.identificationType) > -1) {
        return AE.code
      }
      if ([SENDING_5.code].indexOf(this.details.identificationType) > -1) {
        return AI.code
      }
      return SE.code
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    },
    showDifferenceOnly: {
      get() {
        return !this.showAll
      },
      set(value) {
        this.showAll = !value
      }
    }
  },
  watch: {
    details: {
      immediate: true,
      async handler() {
        if (this.details.resultArray && this.details.resultArray.length > 0) {
          this.resultArray = this.details.resultArray
        } else {
          this.resultArray = this.details.resultJson ? JSON.parse(this.details.resultJson) : []
          this.details.resultArray = this.resultArray
        }
        this.pageNum = 1
      }
    }
  },
  async created() {
    // 为body添加CSS类，用于控制下拉框层级
    document.body.classList.add('intelligent-booking-result-active')

    await cache.load(cacheName.CONFIG)
    this.showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
    this.creditOpen = Number(cache.config.get('creditOpen')) === 1
    this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
    getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
      this.packingList = data
    })
    if (this.details.status === 3) {
      this.showAll = true
    }
  },
  beforeDestroy() {
    // 组件销毁时移除body CSS类
    document.body.classList.remove('intelligent-booking-result-active')
  },
  methods: {
    async handleCreateOrder() {
      // 先保存json信息
      await this.handleSave(false)
      // 多单模式
      // const newJobList = []
      let source = null
      if (this.source === INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) {
        source = SOURCE_REMOTE_BOOKING_SAVE.code
      }
      // 业务保存校验
      this.checkSaveJobList = []
      // 订舱校验
      this.checkBookingJobList = []
      // 保存的提示语 后面订舱弹框可能会显示
      this.saveTips = []
      this.newJobList = []
      this.creditParams = []
      let i = 0
      for (const result of this.resultArray) {
        const resultJson = result.text.data
        const jobData = resultJson.jobJson
        // 属性赋值 发货人 收货人 通知人
        this.convertSft(jobData)
        // const job = await this.converJsonToJob(jobData, resultJson)
        const job = await this.enrichJobJson(jobData)
        job.danUNNo = this.details.uuid
        job.index = i
        const checkJob = lodash.cloneDeep(job)
        if (jobData.ifAutoBooking) {
          // 这块保存之后 需要替换数据
          this.checkBookingJobList.push(job)
        }
        // 这块保存后不在使用，仅用于验证规则显示
        checkJob.uuid = 'addJob_' + getUuid()
        checkJob.jobNo = `${job.fileSourceName}_${i + 1}${this.$t('SeaExport.AllPage2')}`
        this.checkSaveJobList.push(checkJob)
        i++
        this.newJobList.push({ job, source, seaEQ: job.seaEQ, containers: job.containers, WarehouseInfo: job.warehouseInfo, seaCargoDoc: job.seaCargoDoc, copyNumber: job.copyNumber })
        this.creditParams.push(JobUtils.getCreditCheckJob(jobData))
        this.$logger.log('job=========', job)
      }
      // 字段校验
      if (!await this.$refs.resultForm.fieldValid()) {
        return
      }
      // 信控校验
      if (this.creditOpen) {
        const res = await canCreateByCreditInfoDetails(this.creditParams)
        if (res.data && Object.entries(res.data).length > 0) {
          this.creditValidDialog.data = Object.entries(res.data)
          for (const item of this.creditValidDialog.data) {
            item[1] = await JobUtils.checkDateAndAmountExceeded(item[1])
            item[1] = item[1].replace('※' + this.$t('queryJob.ThisHasBeenAutomaticallyCleared'), '')
          }
          this.creditValidDialog.visible = true
          return
        }
      }
      // ifBooking 是最外面的开关
      this.params = { location: LOG_SE_SEA_BOOKING.code, seaExportJobSaveVOS: this.newJobList, ifBooking: true, intelligentDocumentUuid: this.details.uuid, branchId: this.$store.getters.currentOfficeId }

      // // 【远程订舱】生成业务时，不进行【订舱】，无需敏感词提示
      // // 敏感词提示
      // this.checkSensitiveWordDialog.checkSensitiveWordResults = []
      // let ifAutoBooking = false
      // for (let i = 0; i < this.resultArray.length; ++i) {
      //   const resultJson = this.resultArray[i].text.data
      //   const jobData = resultJson.jobJson
      //   // 是否自动订舱需要选是
      //   if (jobData.ifAutoBooking) {
      //     ifAutoBooking = true
      //     break
      //   }
      // }
      //
      // // 只要有任意一个【是否自动订舱】选【是】，且包含敏感词，则出弹窗
      // if (this.checkSensitiveWordDialog.checkSensitiveWordResults.length > 0) {
      //   this.checkSensitiveWordDialog.visible = true
      //   return
      // }
      if (this.useCheckRule && this.checkSaveJobList && this.checkSaveJobList.length > 0) {
        this.loading = getLoading4Cxt()
        await this.checkingJobData(this.checkSaveJobList, CheckRuleConstants.NODE_OCR_CREATE_JOB.code)
        const needCheck = this.checkSaveJobList.filter(p => p.needShowDialog)
        if (needCheck && needCheck.length > 0) {
          this.loading.close()
          // 仅保存业务时  弹出校验业务弹框
          const callBack = async() => {
            this.params.ifNeedSave = true
            this.params.ifBooking = false
            await this.saveAndBooking()
          }
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_OCR_CREATE_JOB.code
          this.batchCheckingWindow.jobs = this.checkSaveJobList
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.closeCallback = null
          this.batchCheckingWindow.visible = true
        } else {
          this.params.ifNeedSave = true
          this.params.ifBooking = false
          await this.saveAndBooking()
        }
      } else {
        await this.saveAndBooking()
      }
    },
    // 保存 or 保存并订舱
    async saveAndBooking() {
      // this.params.ifBooking = ifBooking
      this.loading = getLoading()
      await batchSaveSeaBookingSpaceAndBook(this.params).then(res => {
        // this.checkSensitiveWordDialog.visible = false
        if (res.data.status) {
          this.details.status = res.data.status
        }
        // 还有需要订舱校验的数据
        this.jobList = res.data.jobList
        if (this.useCheckRule && this.jobList && this.jobList.length > 0 &&
          this.checkBookingJobList && this.checkBookingJobList.length > 0) {
          const bookingList = []
          for (const job of this.jobList) {
            // checkBookingJobList 中是 当前页的业务数据
            for (const bookData of this.checkBookingJobList) {
              // 因一页托书可以生成多个业务，_前index代表在哪一页。_之后代表当前页生成的第几个业务
              if (job.pageIndex && (job.pageIndex.indexOf(bookData.index + '_')) >= 0) {
                bookData.jobNo = job.jobNo
                bookData.uuid = job.uuid
                bookingList.push(lodash.cloneDeep(bookData))
                break
              }
            }
          }
          if (bookingList.length > 0) {
            this.batchCheckBooking(bookingList)
          }
        } else {
          this.saveSeaBookingSuccess(res)
        }
      }).finally(() => {
        // this.checkSensitiveWordDialog.visible = false
        this.loading.close()
      })
    },
    // 带入业务补充信息
    async bringInBusinessInformation() {
      // 先保存json信息
      await this.handleSave(false)
      // 空进提单 需要校验 是否选择了 操作模式
      if (SENDING_5.code === this.details.identificationType) {
        let index = 0
        const notExistPages = []
        for (const result of this.resultArray) {
          const resultJson = result.text.data
          const jobData = resultJson.jobJson
          // 排除0，0有具体的意义
          if (!jobData.operateType && jobData.operateType !== 0) {
            notExistPages.push(index + 1)
          }
          index = index + 1
        }
        if (notExistPages.length > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectOperateType', [notExistPages.join(',')]))
          return
        }
      }
      // 多单模式
      const newJobList = []
      let index = 0
      for (const result of this.resultArray) {
        const resultJson = result.text.data
        const jobData = resultJson.jobJson
        // 属性赋值 发货人 收货人 通知人
        this.convertSft(jobData)
        const job = await this.enrichJobJson(jobData)
        // 跳转到海出时 cargoDoc seaCargoDoc 需要相同
        job.cargoDoc = job.seaCargoDoc
        job.danUNNo = this.details.uuid
        // 记录托书变更标志
        job.recordDocumentModified = true
        // 托书索引
        job.documentIndex = index
        index = index + 1
        // 复制业务数量
        job.copyNum = job.copyNumber
        newJobList.push(job)
        this.$logger.log('job=========', job)
      }

      if ([INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code, INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code].indexOf(this.source) > -1) { // 远程订舱-海运、远程订舱-空运
        const item = newJobList[0]
        item.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
        item.lob = this.lob
        this.$router.push({
          name: 'RemoteBooking',
          params: {
            view: 'detail',
            action: 'add',
            job: item,
            source: this.source
          }
        })
      } else {
        let routeName
        if (this.lob === SE.code) {
          routeName = 'SeaBooking'
        } else if (this.lob === AE.code) {
          routeName = 'AeBooking'
        } else if (this.lob === AI.code) {
          routeName = 'AiBooking'
        }
        if (newJobList.length === 1 || [AE.code, AI.code].indexOf(this.lob) > -1) {
          const item = newJobList[0]
          item.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
          this.$router.push({
            name: routeName,
            params: { job: item }
          })
        } else {
          let i = 1
          let interval = 0
          for (const item of newJobList) {
            item.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
            setTimeout(() => {
              this.$router.push({
                name: routeName,
                // 先跳转 bookingTreeGrid 再通过 this.$emit('add', job) 跳转到详情页
                query: { openNew: true, key: 'new Job' + i, action: 'add' },
                params: { job: item }
              })
              i++
            }, 500 * interval)
            interval++
          }
        }
      }
      for (const result of this.resultArray) {
        const resultJson = result.text.data
        const jobData = resultJson.jobJson
        // 清空这两个字段，防止因为这些字段产生重复数据
        // 记录托书变更标志
        jobData.recordDocumentModified = null
        // 托书索引
        jobData.documentIndex = null
      }
      this.$emit('close')
      this.refresh()
    },
    // 批量校验订舱EDI
    async batchCheckBooking(bookingList) {
      if (this.useCheckRule) {
        this.loading = getLoading()
        await this.checkingJobData(bookingList, CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code)
        this.loading.close()
        const needCheck = bookingList.filter(p => p.needShowDialog)
        if (needCheck && needCheck.length > 0) {
          const callBack = async() => {
            await this.onlyBooking(bookingList)
          }
          const closeCallback = async() => {
            await this.saveSeaBookingSuccess({ data: {}})
          }
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code
          this.batchCheckingWindow.jobs = bookingList
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.closeCallback = closeCallback
          this.batchCheckingWindow.visible = true
        } else {
          await this.onlyBooking(bookingList)
        }
      } else {
        await this.onlyBooking(bookingList)
      }
    },
    // 仅需要订舱
    async onlyBooking(bookingList) {
      this.loading = getLoading()
      const dataList = []
      for (const result of bookingList) {
        dataList.push({ job: result })
      }
      const params = { location: LOG_SE_SEA_BOOKING.code, seaExportJobSaveVOS: dataList, ifBooking: true, ifNeedSave: false, branchId: this.$store.getters.currentOfficeId }
      await batchSaveSeaBookingSpaceAndBook(params).then(res => {
        if (res.data.status) {
          this.details.status = res.data.status
        }
        this.saveSeaBookingSuccess(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    async checkingJobData(list, code) {
      try {
        await Promise.all(
          Array.from(list, async p => {
            const result = await JobUtils.checkBySaveJobNode({ job: p }, this.lob, code)
            p.needShowDialog = result.needShowDialog
            p.checkingResult = result.rowData
          })
        )
      } catch (error) {
        console.log(error)
      }
    },
    saveSeaBookingSuccess(res) {
      for (const job of this.jobList) {
        const message = res.data[job.jobNo]
        if (message) {
          if (message === JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.chineseName) {
            // 订舱发送成功
            job.saveOrBooking = ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code)
          } else if (message === JOB_BOOKING_STATE_BOOKING.chineseName) {
            job.saveOrBooking = ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING.code)
          } else {
            job.saveOrBooking = ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_FAIL.code)
            job.errorMessage = message
          }
        } else {
          job.saveOrBooking = ColumnUtils.jobBookingState(JOB_BOOKING_STATE_RECORDED_NOT_BOOKING.code)
        }
      }
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ force: true })
      }
      if (!this.jobList || this.jobList.length === 0) {
        this.saveAndBookingDialog.data = res.data
        delete this.saveAndBookingDialog.data.jobList
        delete this.saveAndBookingDialog.data.status
      }
      this.saveAndBookingDialog.visible = true

      // 只有一条默认选中
      if (this.jobList && this.jobList.length === 1) {
        // 默认选中所有叶子节点
        this.$nextTick(() => {
          const api = this.gridOptions && this.gridOptions.api
          if (api) {
            api.forEachLeafNode((node) => {
              node.setSelected(true)
            })
            api.refreshCells({ force: true })
          } else {
            // 如果api尚未准备好，等待一段时间后重试
            setTimeout(() => {
              if (api) {
                this.gridOptions.api.forEachLeafNode((node) => {
                  node.setSelected(true)
                })
                this.gridOptions.api.refreshCells({ force: true })
              }
            }, 100)
          }
        })
      }
    },
    async enrichJobJson(job) {
      job.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
      job.lob = this.lob
      job.fba = false
      // 海出托书
      if (SENDING_0.code === this.details.identificationType) {
        // 刷新装箱信息
        ContainerUtil.autoJustContainerUsages(job)
        if (job.containerUsages) {
          for (const item of job.containerUsages) {
            // （去除循环依赖）
            item.container = null
          }
        }
        job.containerUsages = []
        job.transfering = !!job.transferPortCode
        // 交货地区域
        if (job.destinationPortCode) {
          const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.destinationPortCode)
          job.placeOfDeliveryRegion = port ? port.region : ''
        }

        job.etd = DateUtils.toDateStr(job.etd)
        job.sailingDay = DateUtils.getDateWeek(job.etd)
        // 船公司
        // 船名
        if (job.vessel && job.vessel.length > 64) {
          job.vessel = job.vessel.substr(0, 64)
        }
        await JobUtils.queryCarrierCodeHandler(job)
        let voyageValue = 'V.'
        if (!this.showJudgmentOfVoyageNo) {
          voyageValue = ''
        }
        if (job.voyageFlight) {
          job.voyageFlight = voyageValue + job.voyageFlight
          if (job.voyageFlight && job.voyageFlight.length > 255) {
            job.voyageFlight = job.voyageFlight.substr(0, 255)
          }
        }
        // 品名
        job.cargoEnglishName = job.cargoEnglishName ? job.cargoEnglishName.toUpperCase() : ''
        // 唛头
        job.mark = job.mark ? job.mark.toUpperCase() : ''
        job.fileSourceType = this.details['fileType']
        job.fileSourceName = this.details['fileName']
        job.filePreViewContent = this.details['filePreViewContent']
        job.fileSourceContent = this.details['fileSourceContent']
        // 运费条款
        // 运输条款job
        // 贸易条款
        // 包装
        // 整箱/拼箱  FCL/LCL
        // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
        job.danUNNo = this.details.uuid
        job.signMBL = job.ifAutoBooking
        job.signHBL = false
        job.virtualHBL = false
        job.vgm = false
        job.ams = false
        job.hds = false
        job.comercialInspectation = false
        job.heating = false
        job.itmService = false
        job.mblOnly = false
        job.batch = false
        job.salePrice = false
        job.allocation = false
        job.availableCabinSpace = false

        job.quantityActual = job.quantityContract
        job.weightActual = job.weightContract
        job.cubageActual = job.cubageContract

        // 订舱代码为空时，取船公司
        if (!job.bookingAgent) {
          job.bookingAgent = job.carrierId
        }

        // // 件数
        // const quantityContract = this.changeValue(job, 'quantityContract', ['CASE', 'PKGS', 'CTNS'])
        // if (quantityContract !== 0) {
        //   job.quantityContract = Number(!StrUtils.isEmpty(job.packing) ? quantityContract.replace(job.packing, '') : quantityContract)
        //   job.quantityActual = job.quantityContract
        // }
        // // 毛重
        // const weightContract = this.changeValue(job, 'weightContract', ['KGS', this.$t('SeaExport.KG'), ','])
        // job.weightContract = Number(weightContract)
        // job.weightActual = job.weightContract
        // // 体积
        // const cubageContract = this.changeValue(job, 'cubageContract', ['CBM', this.$t('SeaExport.CBM')])
        // job.cubageContract = Number(cubageContract)
        // job.cubageActual = job.cubageContract
        // 客户
        // 进仓编号
        if (job.warehouseNo) {
          job.jobWarehouseNos = [{ 'warehouseNo': job.warehouseNo }]
        }
        if (job.businessMark) {
          for (const bm of job.businessMark) {
            switch (bm) {
              case 0:
                job.mblOnly = true
                job.signMBL = true
                job.signHBL = false
                break
              case 1:
                job.transfering = true
                break
              case 2:
                job.batch = true
                break
              case 3:
                job.salePrice = true
                break
              case 4:
                job.allocation = true
                break
              case 5:
                job.availableCabinSpace = true
                break
            }
          }
        }
        //
        if (job.arriveDate) {
          const warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
          warehouseInfo.arriveDate = job.arriveDate
          job.warehouseInfo = [warehouseInfo]
        }
        // 带出联动信息
        await this.setOtherInfo(job)
        await this.setBillOfLadingData(job)
      }
      return JSON.parse(JSON.stringify(job, (key, value) => {
        if (typeof value !== 'boolean') {
          if (!value || (Array.isArray(value) && !value.length || (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length))) {
            return undefined
          }
        }
        return value
      }))
    },
    // 联动带出逻辑
    async setOtherInfo(newJob) {
      // 揽货类型
      // 根据客户属性的揽货类型。单勾选自揽货=带出"自揽货"，  单勾选指定货=带出"指定货"。  同时勾选= 带出的是"自揽货"
      const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', newJob.customerId)
      const customerDetail = customer ? await Company.loadCustomer(customer.uuid).then(list => list.length > 0 ? list[0] : null) : ''
      if (!newJob.cargoSource && newJob.customerId && Number(newJob.customerId) > 0) {
        let newCargoSource = ''
        if (customer && customerDetail) {
          if (customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          } else if (customerDetail.designated && !customerDetail.seftCanvass) {
            newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          } else if (!customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          }
        }
        newJob.cargoSource = newCargoSource
      }
      if (newJob.cargoSource) {
        // 根据"委托单位+卸货港+指定货"带出指定货代理
        if (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          // 指定货代理
          if (customerDetail && newJob.dischargingPortCode) {
            const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const agent of portDestinationAgents) {
                if (newJob.dischargingPortCode === agent.destinationPort) {
                  newJob.designationAgent = agent.destinationAgentId
                  break
                }
              }
            }
          }
        }

        // 分单运费条款
        if (!newJob.paymentTermHBL) {
          newJob.paymentTermHBL = newJob.paymentTermMBL || ((newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'CC' : 'PP')
        }

        // 贸易条款
        if (!newJob.incoTerm) {
          newJob.incoTerm = (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'FOB' : 'CIF'
        }
      }
      // 计费重量
      if (!newJob.chargeWeight) {
        newJob.chargeWeight = this.handleChargeWeight(newJob.cubageContract, newJob.weightContract)
      }
    },
    // 计算计费重量
    handleChargeWeight(cubage, weight) {
      if (!weight) {
        weight = 0
      }
      if (!cubage) {
        cubage = 0
      }
      if (isNaN(weight) || isNaN(cubage)) {
        return 0
      }
      weight = weight ? Number(weight) : 0
      cubage = cubage ? Number(cubage) : 0
      //
      weight = weight ? weight / 1000 : weight
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      return parseFloat(weight.toFixed(3))
    },
    async handleSave(closeDialog = true) {
      const loading = getLoading4Cxt(this)
      this.resultArray.forEach(result => {
        const resultJson = result.text.data
        // 清除焦点
        resultJson.curFocus = ''
      })
      this.resultArray[0].ocrRecognitionFields = this.$refs.resultForm.ocrRecognitionFields // 识别字段
      this.resultArray[0].ocrOtherFields = this.$refs.resultForm.ocrOtherFields // 录单字段
      const params = {
        uuid: this.details.uuid,
        resultArray: this.resultArray
      }

      await saveResultJsonCwmi(params).then(res => {
        if (closeDialog) {
          this.$message.success(this.$t('Message.SaveSuccessfully'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 转换收发通地址
    convertSft(job) {
      const shipper = job.shipper
      const consignee = job.consignee
      const notifyParty = job.notify
      this.splitSft(shipper, 'shipperLine', job)
      this.splitSft(consignee, 'consigneeLine', job)
      this.splitSft(notifyParty, 'notifyLine', job)
    },
    splitSft(oldVal, type, job) {
      for (let j = 0; j <= 7; ++j) {
        job[type + `${j + 1}`] = ''
      }
      if (oldVal) {
        if (typeof oldVal === 'string') {
          const oldValArr = oldVal.split('\n')
          const line7Arr = []
          for (let j = 0; j < oldValArr.length; j++) {
            if (j < 7) {
              job[type + `${j + 1}`] = oldValArr[j] ? oldValArr[j] : ''
              continue
            }
            line7Arr.push(oldValArr[j])
          }
          if (line7Arr.length > 0) {
            job[type + '7'] = line7Arr.join(',')
          }
        }
      }
    },
    handleClose() {
      this.$emit('close')
    },
    refresh() {
      this.$emit('success')
    },
    showAllChange() {
      this.showAll = !this.showAll
    },
    handleToggleChange(value) {
      this.showAll = !value
    },
    scnChange(job, newJob, sourceField, targetField, de) {
      for (let i = 7; i >= 0; --i) {
        if (job[sourceField + i]) {
          newJob[targetField + i] = job[sourceField + i].toUpperCase()
        } else {
          // 设置默认值
          if (de) {
            newJob[targetField + i] = ''
          }
        }
      }
    },
    toDateStr(dateStr) {
      if (!dateStr) {
        return ''
      }
      // 验证日期距离1970年是多长时间，转换之后是否是数字、验证传入的日期是否是数字，若是数字则长度不能少于8位
      if (isNaN(Date.parse(dateStr)) || dateStr.length < 8) {
        return ''
      }
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 验证日期转换之后年月日是否正确
      if (isNaN(year) || isNaN(month) || isNaN(day) || month <= 0 || month > 12 || day < 0 || day > 31) {
        return ''
      }
      return DateUtils.formatStandardDate(date)
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        result = job[targetField]
        if (typeof result === 'string') {
          result = result.trim()
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    },
    changeCodeValue(job, fieldKey, typeName, sourceField, targetField, useCode) {
      let result = null
      if (!StrUtils.isEmpty(job[fieldKey].value)) {
        // irs 返回关键字
        if (job[fieldKey].hasOwnProperty('code')) {
          result = job[fieldKey].code
        }
        //
        if (!StrUtils.isEmpty(result) && useCode) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), result, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
        if (StrUtils.isEmpty(result)) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), job[fieldKey].value, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
      }
      return result
    },
    // 跳转业务 or 业务
    toJobOrBooking(event) {
      if (event.target.tagName.toLowerCase() === 'a' || event.target.closest('a')) {
        this.handleClose()
      }
    },
    onRowClicked(event) {
      this.selectedItem = event.data
    },
    exportTemplateHandler() {
      const selects = this.gridOptions.gridApi.getSelectedRows()
      if (!selects || selects.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const jobKeys = Array.from(selects, p => p.uuid)
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = {}
        params.category = 'BOOKING'
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = jobKeys
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = jobKeys
        }
        this.templateSelectorDialog.ctx = new SeaExportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.prePrintCallback = this.prePrintCallback
        this.templateSelectorDialog.visible = true
      })
    },
    async prePrintCallback(event) {
      const selects = this.gridOptions.gridApi.getSelectedRows()
      if (event.template && selects) {
        for (const select of selects) {
          const params = {}
          params.category = 'BOOKING'
          params.ctx = new SeaExportJob(select)
          params.jobuuid = select.uuid
          params.JOB_UUID = select.uuid
          // 启用模板名称自定义功能
          await this.getCommonTemplateName(params, event.template)
          await this.loadSuccessHandlerV3(params, event.documentType, event.template)
        }
      }
    },
    // 自定义模板名称
    async getCommonTemplateName(data, template) {
      // 启用模板名称自定义功能
      if (parseInt(cache.config.get('templateNameRuleButton')) === 1) {
        const item = {}
        item.anyStr = '' // UUID
        item.anyStr1 = data.jobuuid || '' // jobUuid
        item.anyStr2 = template.uuid // documentTypeUuid
        item.anyStr3 = 'BOOKING'
        item.anyStr4 = template.name // templateName
        item.anyInteger = parseInt(cache.config.get('templateNameRuleButton')) // templateNameRuleButton
        await getTemplateName(item).then(res => {
          // V2模板自定义名称规则回调函数
          const result = res.data
          if (result.hasOwnProperty('templateRuleName') && result.templateRuleName) {
            data.templateRuleName = decodeURIComponent(result.templateRuleName)
          } else {
            data.templateRuleName = ''
          }
        })
      }
    },
    async loadSuccessHandlerV3(data, documentType, template) {
      data.designMode = 0
      data.documentType = documentType
      return await StimulSoftUtil.stiReportPreview(template, data.ctx, data, 1)
    },
    async copyHandler() {
      const selects = this.gridOptions.gridApi.getSelectedRows()
      if (!selects || selects.length === 0 || selects.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectBusinessTip'))
        return
      }
      // 查询计费系统是否开通托书
      const loading = getLoading4Cxt(this)
      await checkBsItemOpened(SystemConstants.TYPE_Shipping).then(res => {
        if (!res.data || res.data === -1) {
          // 计费未开通
          this.$message.warning(this.$t('CargoMsg.Cargo_UnopenedService'))
          return
        } else if (res.data === -2) {
          // 计费开通，余额不足
          this.$message.warning(this.$t('CargoMsg.Cargo_RemainingAmountNotEnough2'))
          return
        }
        this.doCopyHandler(selects[0])
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    closeDialog() {
      this.saveAndBookingDialog.visible = false
      this.refresh()
    },
    async overrideSystemBillHandler() {
      // 先保存json信息
      await this.handleSave(false)
      // 字段校验
      if (!await this.$refs.resultForm.fieldValid()) {
        return
      }
      const loading = getLoading4Cxt(this)
      await overrideSystemBillFunc({ uuid: this.details.uuid, index: this.pageNum - 1 }).then(res => {
        if (res.data) {
          this.$emit('success')
        }
      }).finally(() => {
        loading.close()
      })
    },
    doCopyHandler(data) {
      const loading = getLoading4Cxt(this)
      let index = 0
      if (data.pageIndex) {
        const pageIndex = data.pageIndex.split('_')
        index = Number(pageIndex[0])
      }
      copyIntelligentDocumentFunc({ uuid: this.details.uuid, index: index }).then(res => {
        this.saveAndBookingDialog.visible = false
        this.$emit('copyIntelligentDocument', res.data)
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    saveAndBookingDialogClose() {
      this.saveAndBookingDialog.visible = false
      // 保存业务成功，跳转下一票业务
      if (this.details.status === UPLOAD_STATUS_COMPLETE_ORDER.code) {
        this.$emit('toNext')
      }
    },
    async setBillOfLadingData(job) {
      const billOfLadingSynMode = parseInt(cache.config.get('BillOfLadingSynMode'))
      const isInsidePacking = parseInt(cache.config.get('seaInsidePacking'))
      const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(cache.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1
      // 历史提单数据处理
      job.seaCargoDoc = []
      const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
      if (!StrUtils.isEmpty(job.orderType)) {
        hblDoc.releaseType = job.orderType
      }
      hblDoc.cargoEnglishName = job.cargoEnglishName
      hblDoc.cargoManifestName = job.cargoEnglishName
      hblDoc.mark = job.mark
      if (!hblDoc.uuid || !hblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === job.packing)
        const packingName = job.jobState !== -1 ? (packing ? packing.name : job.packing) : ''
        hblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
      }
      if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        hblDoc.packing = job.packing
        const packing = this.packingList.find(p => p.code === job.packing)
        hblDoc.packingName = packing ? packing.name : job.packing
      }
      if (isInsidePacking === 1) {
        hblDoc.insidePacking = job.insidePacking
      }
      hblDoc.containerSum = ContainerUtil.getSeaeqNumberStr(job)
      // new SeaExportJob(job).copySCNotifyToDoc(new SeaCargoDoc(hblDoc))
      if (!hblDoc.freightTermHBL && job.freightTermHBL) {
        hblDoc.freightTermHBL = job.freightTermHBL
      }
      CargoDocUtil.changeJobSynToBillOfLading(job, hblDoc)
      await SeaCargoDoc.copyInfoFromSeaExportJob(job, hblDoc)
      if (job.seaCargoDoc && job.seaCargoDoc.length > 0) {
        job.seaCargoDoc = [...job.seaCargoDoc, hblDoc]
      } else {
        job.seaCargoDoc = [hblDoc]
      }

      const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
      if (!StrUtils.isEmpty(job.orderType)) {
        mblDoc.releaseType = job.orderType
      }
      if (mblDoc.releaseType === 1) {
        mblDoc.blCopyNumber = 'THREE'
        mblDoc.BLNumber = 'THREE'
      } else {
        mblDoc.blCopyNumber = 'ONE'
        mblDoc.BLNumber = 'ONE'
      }
      if (job.paymentData) {
        const paymentDataList = job.paymentData.split('\n')
        for (let i = 0; i < 7; i++) {
          if (paymentDataList.length > i) {
            mblDoc['paymentLine' + (i + 1)] = paymentDataList[i]
          } else {
            mblDoc['paymentLine' + (i + 1)] = ''
          }
        }
      }
      mblDoc.cargoManifestName = job.cargoEnglishName
      if (!mblDoc.uuid || !mblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === job.packing)
        const packingName = job.jobState !== -1 ? (packing ? packing.name : job.packing) : ''
        mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
      }
      if (isInsidePacking === 1) {
        mblDoc.insidePacking = job.insidePacking
      }
      mblDoc.containerSum = ContainerUtil.getSeaeqNumberStr(job)
      await CargoDocUtil.initMBLProperties(mblDoc, job, 'add')
      // 勾选了mbl 才同步收发通
      if (job.signMBL) {
        new SeaCargoDoc(mblDoc).copyBasicShipper(job)
        new SeaCargoDoc(mblDoc).copyBasicConsignee(job)
        new SeaCargoDoc(mblDoc).copyBasicNotify(job)
      }
      if (syncCustomerShippingInfoBothBolAndBasicTab) {
        new SeaCargoDoc(mblDoc).copyBasicAlsoNotify(job, true, syncCustomerShippingInfoBothBolAndBasicTab)
      }
      if (hblDoc) {
        await CargoDocUtil.initHBLProperties(hblDoc, job)
      }
      await CargoDocUtil.checkOverseaAgentProperties(job)
      if (job.insideQuantity >= 0) {
        mblDoc.insideQuantity = job.insideQuantity
      }
      if (!StrUtils.isEmpty(job.packing)) {
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          mblDoc.packing = job.packing
          const packing = this.packingList.find(p => p.code === job.packing)
          mblDoc.packingName = packing ? packing.name : job.packing
        }
      }
      if (!job.uuid) {
        let packingName = ''
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          const packing = this.packingList.find(p => p.code === job.packing)
          packingName = packing ? packing.name : job.packing
          if (!mblDoc.packingName) {
            mblDoc.packingName = packingName
          }
        }
        if (job.quantityActual > 0) {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
        } else {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityContract, packingName)
        }
        if (!mblDoc.freightTermHBL && job.freightTerm) {
          mblDoc.freightTermHBL = job.freightTerm
        }
        CargoDocUtil.changeJobSynToBillOfLading(job, mblDoc)
      }
      if (job.shipperCode) {
        mblDoc.shipperCode = job.shipperCode
      }
      if (job.consigneeCode) {
        mblDoc.consigneeCode = job.consigneeCode
      }
      if (job.notifyCode) {
        mblDoc.notifyCode = job.notifyCode
      }
      if (job.shipperId) {
        mblDoc.shipperId = job.shipperId
      }
      if (job.notifyId) {
        mblDoc.notifyId = job.notifyId
      }
      if (job.consigneeId) {
        mblDoc.consigneeId = job.consigneeId
      }
      if (job.seaCargoDoc && job.seaCargoDoc.length > 0) {
        job.seaCargoDoc = [...job.seaCargoDoc, mblDoc]
      } else {
        job.seaCargoDoc = [mblDoc]
      }
    }
  }
}
</script>

<style lang="scss">
// 整个组件容器的层级提升
.intelligent-booking-result-container {
  z-index: 2100 !important;
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  // 确保所有子元素都有足够的层级
  * {
    position: relative;
  }

  // 主要内容区域
  .main-content-area {
    flex: 1;
    min-height: 0; // 重要：允许flex子项收缩
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  // 内容调整容器
  .content-resize-container {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  // 左侧面板
  .left-panel {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  // 右侧面板
  .right-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  // 表单内容区域
  .form-content-area {
    flex: 1;
    overflow: auto;
    padding-top: 40px; // 为切换开关预留空间
    min-height: 0; // 重要：允许flex子项收缩
  }

  // 表单容器
  .form-container {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  // 底部区域
  .bottom-area {
    height: 60px;
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #fff;
    border-top: 1px solid #e8e8e8;
    flex-shrink: 0; // 不允许收缩
  }

  // 分页容器
  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // 底部按钮
  .bottom-buttons {
    position: absolute;
    right: 20px;
    display: flex;
    gap: 12px;
    z-index: 2110;
  }

  // 切换模式容器
  .toggle-mode-container {
    position: absolute;
    top: 8px;
    right: 20px;
    z-index: 2110;
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .toggle-label {
      font-size: 12px;
      font-weight: 500;
      color: #606266;
      white-space: nowrap;
    }

    // 确保开关组件有足够高的层级
    .el-switch {
      z-index: 2111;
    }
  }

  // 响应式设计 - 小屏幕适配
  @media (max-height: 600px) {
    .form-content-area {
      padding-top: 35px; // 减少顶部间距
    }

    .toggle-mode-container {
      top: 4px;
      right: 10px;
      padding: 2px 6px;

      .toggle-label {
        font-size: 11px;
      }
    }

    .bottom-area {
      height: 50px;
      min-height: 50px;
    }

    .bottom-buttons {
      right: 10px;
      gap: 8px;

      .el-button {
        padding: 8px 15px;
        font-size: 12px;
      }
    }
  }

  // 超小屏幕适配
  @media (max-height: 480px) {
    .form-content-area {
      padding-top: 30px;
    }

    .toggle-mode-container {
      top: 2px;
      right: 8px;
      padding: 2px 4px;

      .toggle-label {
        display: none; // 超小屏幕隐藏文字
      }
    }

    .bottom-area {
      height: 45px;
      min-height: 45px;
    }

    .bottom-buttons {
      right: 8px;
      gap: 6px;

      .el-button {
        padding: 6px 12px;
        font-size: 11px;
      }
    }

    // 分页组件也适配小屏幕
    .pagination-container {
      ::v-deep .el-pagination {
        .el-pager li {
          min-width: 25px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
        }

        .btn-prev,
        .btn-next {
          min-width: 25px;
          height: 25px;
          line-height: 25px;
        }
      }
    }
  }
}

.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  // 提升整个对话框的层级
  z-index: 2100 !important;

  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
    // 确保内容区域也有足够高的层级
    z-index: 2101;
    position: relative;
  }
}

// 仅针对当前组件内的子表单组件提升层级
.intelligent-booking-result-container {
  .result-form-se,
  .result-form-ai,
  .result-form-ae,
  .result-form-se-td {
    // 确保组件本身有足够的层级
    z-index: 2105;
    position: relative;

    // 内部所有选择器组件
    .el-select,
    .el-date-picker,
    .el-time-picker,
    .el-cascader,
    .el-autocomplete,
    .el-color-picker {
      z-index: 2106;
      position: relative;
    }
  }
}

// 仅针对当前组件内的下拉框提升层级 - 不影响其他组件
.intelligent-booking-result-container {
  // 只影响此容器内的Element UI组件下拉框
  .el-select-dropdown,
  .el-picker-panel,
  .el-time-panel,
  .el-cascader-panel,
  .el-popper,
  .el-tooltip__popper,
  .el-autocomplete-suggestion,
  .el-color-dropdown,
  .el-dropdown-menu {
    z-index: 100000 !important;
  }

  // 只影响此容器内的自定义组件下拉框
  .cargo-select-dropdown,
  .cargo-office-select-dropdown,
  .custom-dropdown {
    z-index: 100000 !important;
  }
}

// 针对挂载到body上的下拉框 - 使用智能检测避免影响其他组件
body.intelligent-booking-result-active {
  .el-select-dropdown,
  .el-picker-panel,
  .el-time-panel,
  .el-cascader-panel,
  .el-popper,
  .el-tooltip__popper,
  .el-autocomplete-suggestion,
  .el-color-dropdown,
  .el-dropdown-menu {
    z-index: 100000 !important;
  }
}

// 特殊处理：当在沃宝智能对单容器中时，使用更高的层级
.wobao-intelligent-booking-container body.intelligent-booking-result-active,
body.intelligent-booking-result-active .wobao-intelligent-booking-container {
  .el-select-dropdown,
  .el-picker-panel,
  .el-time-panel,
  .el-cascader-panel,
  .el-popper,
  .el-tooltip__popper,
  .el-autocomplete-suggestion,
  .el-color-dropdown,
  .el-dropdown-menu {
    z-index: 100001 !important;
  }
}

// 只针对智能订舱结果组件内的copy-icon提升层级 - 不影响其他组件
.intelligent-booking-result-container {
  .cargo-advance-select-wrapper .copy-icon {
    position: absolute;
    top: -13px;
    right: 5px;
    height: 28px;
    font-size: 14px;
    z-index: 200000 !important;
  }
}

// 针对智能订舱结果组件，提升 message 提示的层级，确保在所有元素之上显示
body.intelligent-booking-result-active {
  .el-message {
    z-index: 200001 !important;
  }

  .el-message-box {
    z-index: 200001 !important;
  }

  .el-loading-mask {
    z-index: 200000 !important;
  }

  // 确保其他系统级提示也不被覆盖
  .el-notification {
    z-index: 200001 !important;
  }
}
</style>
